import axios from "axios";
import v2_client from "ui-common/api/OpenClient";
import {isNextGenEnabled} from "../AppSettings";


export const v3_client = axios.create({
    baseURL: process.env.REACT_APP_BASE_PUBLIC_API_URL
});


const getApiClient = () => {
    if ( isNextGenEnabled() ) {
        return v3_client;
    }

    return v2_client;
}

export default getApiClient;